import { Info } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import React from "react";
import { useHistory } from "react-router-dom";
import { getFinalState, getReleaseInfo } from "../../recoil/helpers";
import { PatientReleaseStatus } from "../../recoil/types";
import { REQUISITION_URL } from "../../utils/urlConstants";
import {
  PatientReleaseReleaseIndicator,
  PatientReleaseStatusIndicator,
  PatientReleaseTooltipRow,
  ReportsCellWrapper,
} from "./Grid.styles";
import { CellRendererProps } from "./types";

export const getReleaseGridInfo = (
  carrierReleaseStatus: PatientReleaseStatus,
  aneuploidyReleaseStatus: PatientReleaseStatus,
): PatientReleaseStatus => {
  if (
    carrierReleaseStatus === "not_pp_enabled" ||
    aneuploidyReleaseStatus === "not_pp_enabled"
  ) {
    return "not_pp_enabled";
  }
  if (
    carrierReleaseStatus === "releasable" ||
    aneuploidyReleaseStatus === "releasable"
  ) {
    return "releasable";
  }
  if (
    carrierReleaseStatus === "notification_queued" ||
    aneuploidyReleaseStatus === "notification_queued"
  ) {
    return "notification_queued";
  }
  if (
    getFinalState(carrierReleaseStatus) === "unreleased" ||
    getFinalState(aneuploidyReleaseStatus) === "unreleased"
  ) {
    return "unreleased";
  }
  if (
    carrierReleaseStatus === "processing" ||
    aneuploidyReleaseStatus === "processing"
  ) {
    return "processing";
  }
  if (
    carrierReleaseStatus === "notified" ||
    aneuploidyReleaseStatus === "notified" ||
    getFinalState(carrierReleaseStatus) === "released" ||
    getFinalState(aneuploidyReleaseStatus) === "released"
  ) {
    return "released";
  }
  if (
    carrierReleaseStatus === "viewed" ||
    aneuploidyReleaseStatus === "viewed"
  ) {
    return "viewed";
  }
  if (
    carrierReleaseStatus === "downloaded" ||
    aneuploidyReleaseStatus === "downloaded"
  ) {
    return "downloaded";
  }
  return "unreleased";
};

export const ReleasePatientCell: React.FC<CellRendererProps> = ({
  data,
  setPatientReleaseModal,
  node,
  tabType,
  deviceType,
  context,
}) => {
  const overAll = getReleaseGridInfo(
    data.carrierReleaseStatus,
    data.aneuploidyReleaseStatus,
  );
  const history = useHistory();

  const InfoToolTip =
    overAll === "releasable" ? (
      <PatientReleaseTooltipRow>
        By clicking this button, a modal will open that allows you to release
        the report to the patient portal. Patient will have to take action to
        sign on and view report.
      </PatientReleaseTooltipRow>
    ) : (
      <div>
        <PatientReleaseTooltipRow>
          <b>Carrier Report:</b> {getReleaseInfo(data.carrierReleaseStatus)}
        </PatientReleaseTooltipRow>
        <hr />
        <PatientReleaseTooltipRow>
          <b>Aneuploidy Report:</b>{" "}
          {getReleaseInfo(data.aneuploidyReleaseStatus)}
        </PatientReleaseTooltipRow>
      </div>
    );
  const Icon = (
    <Tooltip arrow title={overAll === "not_pp_enabled" ? "" : InfoToolTip}>
      <Info />
    </Tooltip>
  );
  return (
    <ReportsCellWrapper
      onClick={() => {
        if (deviceType === "desktop") {
          localStorage?.setItem(
            `btoProviderCurrentPage${tabType}`,
            JSON.stringify(context?.currentPage ?? 0),
          );
          if (data.sfID) {
            history.push(`${REQUISITION_URL}/${data.sfID}`);
          }
        }
      }}
    >
      {overAll === "releasable" ? (
        <PatientReleaseReleaseIndicator
          onClick={(e) => {
            if (deviceType === "desktop") {
              e.stopPropagation();
            }
            return (
              setPatientReleaseModal &&
              node &&
              setPatientReleaseModal({ row: data, node })
            );
          }}
          button
        >
          Release {Icon}
        </PatientReleaseReleaseIndicator>
      ) : (
        <PatientReleaseStatusIndicator
          onClick={(e) => {
            if (deviceType === "desktop") {
              e.stopPropagation();
            }
            if (overAll !== "not_pp_enabled") {
              return (
                setPatientReleaseModal &&
                node &&
                setPatientReleaseModal({ row: data, node })
              );
            }
          }}
          button
        >
          {getReleaseInfo(overAll)} {overAll !== "not_pp_enabled" && Icon}
        </PatientReleaseStatusIndicator>
      )}
    </ReportsCellWrapper>
  );
};
